import React from 'react';
import session from 'services/sessionService';
import dealerApi from 'api/dealer';
import Loader from 'components/loader';

export const POS_PERMISSIONS = {
  DETAILED_REPORTING: 'DetailedReporting',
  PURCHASE_HISTORY: 'PurchaseHistory',
  DASHBOARD_TILES: 'Dashboard',
};

export const connectToPOSPermissions = permission => Comp => {
  return class POSPermission extends React.Component {
    static displayName = `hasPOSPermission(${Comp.displayName || Comp.name})`;

    state = {
      loaded: false,
    };

    componentWillMount() {
      const user = session.getUser();

      if (user.isDealerAdmin) {
        this.setState({loaded: true});
        return;
      }

      let permissionName = user.isAdmin ?
        `manager${permission}` :
        `tester${permission}`;

      dealerApi.getDealer(user.dealerId)
        .then(dealer => {
          if (dealer[permissionName]) {
            this.setState({loaded: true});
            return;
          }

          location.hash = '';
        });
    }

    render() {
      return <Loader loaded={this.state.loaded}>
        <Comp {...this.props} />
      </Loader>;
    }
  };
};
